<!--SUBSCRIPTION TILE-->
<!--SUBSCRIPTION TILE CARDS-->
<div [ngClass]="!isLightMode ? 'neutral-background' : ''">
  <div class="flexbox gap-2-rem wrapper">
    <app-tile-layout class="subscription-tile equal-width-column" maxColumns="3" isVertical="true">
      <ng-container
        *ngFor="
          let subscriptionTileItem of subscriptionTiles | slice : 0 : 3;
          trackBy: trackBySubscriptionTileItem
        ">
        <li>
          <div class="subscription-tile-container">
            <ng-template
              [ngIf]="
                subscriptionTileItem?.imageIcon === '' && subscriptionTileItem?.imageUrl === ''
              ">
              <a
                id="{{ subscriptionTileItem?.slug }}"
                [attr.data-beyond-id]="subscriptionTileItem?.slug"
                (click)="
                  sendGoogleAnalytics('Subscription Tile', 'click', subscriptionTileItem?.slug)
                "
                class="gen-neutral-black-link bold"
                href="/{{ subscriptionTileItem?.slug }}">
                {{ subscriptionTileItem.title }}
              </a>
              <p class="subscription-tile-text">{{ subscriptionTileItem?.description }}</p>
            </ng-template>
            <ng-template
              [ngIf]="subscriptionTileItem?.imageIcon && subscriptionTileItem?.imageUrl === ''">
              <a
                id="{{ subscriptionTileItem?.slug }}"
                [attr.data-beyond-id]="subscriptionTileItem?.slug"
                (click)="
                  sendGoogleAnalytics('Subscription Tile', 'click', subscriptionTileItem?.slug)
                "
                class="gen-neutral-black-link-no-text-decoration"
                href="/{{ subscriptionTileItem?.slug }}">
                <i class="{{ subscriptionTileItem?.imageIcon }} icon red medium"></i>
                <span class="margin-left-x-small"> {{ subscriptionTileItem.title }} </span>
              </a>
            </ng-template>
            <ng-template
              [ngIf]="subscriptionTileItem?.imageIcon === '' && subscriptionTileItem?.imageUrl">
              <a
                id="{{ subscriptionTileItem?.slug }}"
                [attr.data-beyond-id]="subscriptionTileItem?.slug"
                (click)="
                  sendGoogleAnalytics('Subscription Tile', 'click', subscriptionTileItem?.slug)
                "
                href="/{{ subscriptionTileItem?.slug }}">
                <img
                  src="/assets/img/{{ subscriptionTileItem?.imageUrl }}"
                  alt="{{ subscriptionTileItem?.title }} logo" />
              </a>
              <a href="/{{ subscriptionTileItem?.slug }}" class="learn-more-tile"
                >Learn more <i></i
              ></a>
            </ng-template>
          </div>
        </li>
      </ng-container>
    </app-tile-layout>
    <!-- <app-card-container
  [title]="'Learning Subscriptions'"
  [cardType]="'subscription'"
  [description]="
    'New to the Genesys ecosystem and looking for an economical way to become a subject matter expert on your Genesys platform? A learning subscription is the best way to maximize your time and budget for training. 
    Each learning subscription provides individual users with access to the top training and certifications for each platform for one year. Learn more about each of the subscriptions below!'
  "
  [containerBackgroundCss]="!isLightMode ? 'neutral-background' : ''">
  <div class="text-align-center margin-top-large">
    <app-route-button
      id="subscription-see-all-products"
      [actionButtonCss]="'action-button'"
      [attr.data-beyond-button-id]="'subscription-see-all-products'"
      [route]="'products'"
      (buttonClick)="sendGoogleAnalytics('subscription', 'click', 'See All Subscriptions')"
      [actionLabel]="'See All Subscriptions'"
      [customButtonCss]="['btn-primary', 'larger-btn', 'padding-right-small']">
    </app-route-button>
  </div>
</app-card-container> -->
    <div class="margin-left-large margin-top-large">
      <h1 class="bold">Learning Subscriptions</h1>
      <br />
      <br />
      <p class="bold">
        New to the Genesys ecosystem and looking for an economical way to become a subject matter
        expert on your Genesys platform? A learning subscription is the best way to maximize your
        time and budget for training.<br />
        <br />
        Each learning subscription provides individual users with access to the top training and
        certifications for each platform for one year. Learn more about each of the subscriptions
        below!
      </p>
      <div class="margin-top-large">
        <app-route-button
          id="subscription-see-all-products"
          [actionButtonCss]="'action-button'"
          [attr.data-beyond-button-id]="'subscription-see-all-products'"
          [route]="'products'"
          (buttonClick)="sendGoogleAnalytics('subscription', 'click', 'See All Subscriptions')"
          [actionLabel]="'See All Subscriptions'"
          [customButtonCss]="['btn-primary', 'larger-btn', 'padding-right-small']">
        </app-route-button>
      </div>
    </div>
  </div>
</div>
<!--END SUBSCRIPTION TILE-->
